module.exports = __webpack_public_path__ + "img/quality1.f156907b.jpg";